export default __webpack_public_path__ + "ab95362b88d4837c0ed49d8d6e6cd22b.png";